const syncMainProductWithVoucherInCart = () => {
    let data_line_id_ajax = [];
    const moveAlongLineAjax = function (temp_product) {
        if (data_line_id_ajax.length) {
            var length = data_line_id_ajax.length;
            var request = data_line_id_ajax.shift();
            $.ajax({
                url: "/cart/change.js",
                type: "POST",
                data: {quantity: 0, line: request.line},
                dataType: "json",
                success: function (data) {
                    if (length === 1) {
                        var var_id = localStorage.getItem("variantid");
                        clearCart();
                        if (temp_product) {
                            $.getJSON('/cart.js', function (cart) {
                                var myJson = cart.items;
                                var gwp_base = myJson.filter(function (item) {
                                    return item.id == var_id;
                                });
                                if (gwp_base.length > 0) {
                                    $('.discount_code').remove();
                                    $.ajax({
                                        url: "/cart/change.js",
                                        type: "POST",
                                        data: {quantity: 0, id: var_id},
                                        dataType: "json",
                                        success: function (data) {
                                            localStorage.removeItem("main_product_id");
                                            localStorage.removeItem("vouchercode");
                                            localStorage.removeItem("redemption_fee");
                                            $.getJSON('/cart.js', function (cart_new) {
                                                document.dispatchEvent(new CustomEvent('cart:refresh:force', { detail: { cart_new } }));
                                            });
                                        },
                                        error: function (error) {
                                            $.getJSON('/cart.js', function (cart_new) {
                                                document.dispatchEvent(new CustomEvent('cart:refresh:force', { detail: { cart_new } }));
                                            });
                                        }
                                    });
                                } else {
                                    $('.minicart-message').text('Item was removed successfully.');
                                    $('.minicart-message').addClass('showmessage');
                                }
                            });
                        } else {
                            $('.minicart-message').text('Item was removed successfully.');
                            $('.minicart-message').addClass('showmessage');
                        }
                        $.getJSON('/cart.js', function (cart_new) {
                            document.dispatchEvent(new CustomEvent('cart:refresh:force', { detail: { cart_new } }));
                        });
                    } else {
                        var temp = false;
                        moveAlongLineAjax(temp);
                    }
                },
                error: function (error) {
                }
            });
        }
    };
    $('.product_remove a').click(function (e) {
        var temp_product = false;
        var min_p_id = localStorage.getItem("main_product_id");
        var prod_id = $(this).attr('product_id');
        var var_id = localStorage.getItem("variantid");
        var c_d_code = localStorage.getItem("vouchercode");
        $('.minicart-message').removeClass('showmessage');
        var toRemove = "";
        e.preventDefault();
        if ($(this).closest('.cart__item').hasClass('cart__drawer-product-addon')) {
            data_line_id_ajax.push({
                line: parseInt($(this).parents('.cart__item.cart__drawer-product-addon').data('line-id')),
                quantity: 0
            });
        } else {
            var mainpdptimestamp = $(this).parents('.cart__item').data('timestamp');
            data_line_id_ajax.push({
                line: parseInt($(this).parents('.cart__item').data('line-id')),
                quantity: 0
            });
            if (mainpdptimestamp !== "") {
                $('.over_cart .cart__item:not(.main-drwr-prd)').each(function () {
                    if ($(this).data('timestamp') === mainpdptimestamp) {
                        data_line_id_ajax.push({
                            line: parseInt($(this).data('line-id')),
                            quantity: 0
                        });
                    }
                });
            }
        }
        if (c_d_code && min_p_id === prod_id) {
            temp_product = true;
        }

        data_line_id_ajax = data_line_id_ajax.reverse();
        moveAlongLineAjax(temp_product)
        return false;
    });
}

const addUpsellFromPopup = (dataNew, reverseArray) => {
    if (!dataNew.length) return;

    const processNextRequest = () => {
        if (!reverseArray.length) return;

        const request = reverseArray.shift();

        $.ajax({
            url: "/cart/add.js",
            type: "POST",
            data: {
                quantity: request.quantity,
                id: request.variantId,
                properties: request.properties
            },
            dataType: "json",
            success: function (data) {
                window.dispatchEvent(new CustomEvent("AddToCartSuccess", {
                    detail: {
                        item: { quantity: request.quantity, id: request.variantId, properties: request.properties },
                        data
                    }
                }));

                if (reverseArray.length === 0) {
                    $('.upsell-product').find('input[type=checkbox]:checked').prop('checked', false);
                    $.fancybox.close();
                    $.getJSON('/cart.js', function (cart) {
                        document.dispatchEvent(new CustomEvent('cart:refresh:force', { detail: { cart } }));
                        $('.minicart-message')
                            .text('Item was added successfully.')
                            .addClass('showmessage');
                        $('.cart-container').addClass('active_link');
                    });
                } else {
                    processNextRequest();
                }
            },
            error: function (error) {
                console.error("Error adding item to cart:", error);
            }
        });
    };

    processNextRequest();
};

const changeCartItems =  async (itemsData) => {
    return new Promise((resolve, reject) => {
        $.ajax({
            url: "/cart/update.js",
            type: "POST",
            data: { updates: itemsData },
            dataType: "json",
            success: function () {
                resolve();
            },
            error: function (error) {
                console.error(error);
                reject(error);
            }
        });
    });
};

const clearCart = () => {
    $.getJSON('/cart.js', function(cart){
        var is_child = false;
        $.each(cart.items, function(index, item) {
            if(item.properties !== null && item.properties._child !== null){
                is_child = true;
            } else{
                is_child = false;
                return false;
            }
        });
        if(is_child){
            $.ajax({
                type: "POST",
                url: '/cart/clear.js',
                success: function(){
                    location.reload();
                },
                dataType: 'json'
            });
        }

        $.ajax({
            url: '/cart/update.js',
            type: 'POST',
            data: {
                attributes: {
                    'voucher': '',
                    'deliveryDate':''
                }
            },
            dataType: "json",
            success: function(data) {

            },
            error: function(error) {
                $this.attr('disabled', false);
            }
        });

    });
}

syncMainProductWithVoucherInCart();

document.addEventListener('cart:refreshed', () => {
    syncMainProductWithVoucherInCart();
});

$('.action_button.upsell-continue-btn').click(function () {
    const p_id = $(this).attr('data_id');
    const popupSelector = `.upsell_popups_${p_id}`;
    const checkboxes = $(`${popupSelector} input[type=checkbox]:checked`);
    const mainProductId = $(`${popupSelector} input.variant.main_variant`).val();
    const timestamp = `custom_build${Math.round(Date.now() / 1000)}`;
    const dataNew = [];

    checkboxes.each(function () {
        const variantId = $(this).val();
        let quantity = parseInt($(this).attr('data-quntity'));
        let properties = { '_custom_build': timestamp, '_child': 'child' };

        if (variantId === mainProductId) {
            properties = { '_custom_build': timestamp, '_main_product': 'yes' };
        }

        dataNew.push({ variantId, quantity, properties });
    });

    const reversedArray = [...dataNew].reverse();
    addUpsellFromPopup(dataNew, reversedArray);
});

document.addEventListener('cart:parent:remove', (e) => {
    const { event, target } = e.detail;
    var data_line_id = [];
    event.preventDefault();

    let cartItemSelector = '.cart__item';
    const targetDataForm = target.closest('[data-cart-form]');
    if (targetDataForm.data('cart-form') === 'mini-cart') {
        cartItemSelector = '.mini-cart__item';
    }

    const targetCartItem = target.closest(cartItemSelector);
    let mainProductTimestamp = targetCartItem.data('timestamp');
    if (mainProductTimestamp !== "") {
        targetDataForm.find(cartItemSelector).each(function () {
            if ($(this).data('timestamp') === mainProductTimestamp) {
                data_line_id.push(0);
            } else {
                data_line_id.push(parseInt($(this).find('.quantity').val()));
            }
        });
    }

    if (data_line_id.length) {
        changeCartItems(data_line_id).then(() => {
            location.reload();
        });
    }
});

if (window.PXUTheme.theme_settings.cart_action === 'ajax') {
    $(document).on('click', '.ajax-submit', function (e) {
        e.preventDefault();
        const $addToCartForm = $(this).closest('form');
        const $addToCartBtn = $addToCartForm.find('.add_to_cart');
        this.recipientForm = $addToCartForm[0].querySelector('[data-recipient-form]');
        $('.warning').remove();
        if (this.recipientForm) {
            this.recipientForm.classList.remove('recipient-form--has-errors');
        }

        // Refresh page on quick shop add to cart if on cart page
        if ($('body').hasClass('cart')) {
            $addToCartForm.submit();
        }

        if($(this).hasClass('popup_upsell')){
            var abc = $(this).siblings('a.upcelpopup');
            abc.trigger('click');
            var p_id = $(this).attr('data_id');
            $("input[data-id='"+p_id+"']").attr('checked', true);
            if($('.product').length > 0){
                var main_p_qty = parseInt($('#quantity').val());
                $('.main_product').attr('data-quntity',main_p_qty);
            }

            var fancy = setInterval(function(){
                if ($(document).find(".fancybox-is-open").length > 0) {
                    clearInterval(fancy);
                    let fancyCloser = $('.fancybox-is-open .fancybox-button.fancybox-close-small');
                    fancyCloser.click(function(){
                        $("input[data-id='"+p_id+"']").attr('checked', false);
                        if($('.collection').length > 0){
                            $('.collection .ajax-submit[data_id='+p_id+']').removeClass('popup_upsell');
                            $('.collection .ajax-submit[data_id='+p_id+']').trigger('click');
                            $('.collection .ajax-submit[data_id='+p_id+']').addClass('popup_upsell');
                        }
                        if($('.product').length > 0){
                            $('.product .upsell_from .ajax-submit').removeClass('popup_upsell');
                            $('.product .upsell_from .ajax-submit').trigger('click');
                            $('.product .upsell_from .ajax-submit').addClass('popup_upsell');
                        }
                    });
                }
            },200);

            return false;
        }

        $.ajax({
            url: '/cart/add.js',
            dataType: 'json',
            cache: false,
            type: 'post',
            data: $addToCartForm.serialize(),
            beforeSend() {
                $addToCartBtn.attr('disabled', 'disabled').addClass('disabled');
                $addToCartBtn.find('span').removeClass('fadeInDown').addClass('animated zoomOut');
            },
            success() {
                $addToCartBtn.find('.checkmark').addClass('checkmark-active');
                window.setTimeout(() => {
                    $addToCartBtn.removeAttr('disabled').removeClass('disabled');
                    $addToCartBtn.find('.checkmark').removeClass('checkmark-active');
                    $addToCartBtn.find('span').removeClass('zoomOut').addClass('fadeInDown');
                }, 1000);
                $.ajax({
                    url: '/cart.js',
                    dataType: 'json',
                    cache: false,
                    success(cart) {
                        setTimeout(function () {
                            document.dispatchEvent(new CustomEvent('cart:refresh:force', { detail: { cart } }));
                            if ($('body').hasClass('fancybox-active')) {
                                $.fancybox.close();
                            }
                            if ($('#header').is(':visible')) {
                                $('#header .cart-container').addClass('active_link');
                            } else if ($('.sticky_nav--stick').length) {
                                $('.sticky_nav .cart-container').addClass('active_link');
                            } else {
                                $('.top-bar .cart-container').addClass('active_link');
                            }

                            // block scrolling on mobile
                            if (window.PXUTheme.media_queries.medium.matches) {
                                const $cartContainer = $(this).parent();
                                if ($cartContainer.hasClass('active_link')) {
                                    $('body').addClass('blocked-scroll');
                                } else {
                                    $('body').addClass('blocked-scroll');
                                }

                                // Scroll to the top of the page unless the header is fixed
                                const header = document.getElementById('header');
                                if (header.classList.contains('mobile_nav-fixed--false')) {
                                    window.scroll({
                                        top: 0,
                                        left: 0,
                                        behavior: 'smooth'
                                    });
                                }
                            }
                        }, 500);
                    }
                });
            },
            error: XMLHttpRequest => {
                const response = eval(`(${XMLHttpRequest.responseText})`);
                $('.warning').remove();
                let warning;
                if (response.errors && response.errors.email) {
                    this.recipientForm.classList.add('recipient-form--has-errors');
                } else {
                    warning = `<p class="warning animated bounceIn">${response.description.replace('All 1 ', 'All ')}</p>`;
                    $addToCartForm.after(warning);
                }
                $addToCartBtn.removeAttr('disabled').removeClass('disabled');
                $addToCartBtn.find('span').text(window.PXUTheme.translation.add_to_cart).removeClass('zoomOut').addClass('zoomIn');
            }
        });
        return false;
    });
}

$(".upcelpopup").fancybox({
    modal: false
});

$.fancybox.defaults.clickOutside = false
$('[data-fancybox]').fancybox({
    closeClick: false
});
